
document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".builder-accordion")
  if(container) {

  function checkProductDetails (action) {
      Object.entries(productDetails).forEach(([key, value]) => {
          if(action === 'load' || action === 'plus'){
          //reset all top messages
              document.querySelectorAll(`div[data-current-index="${value.index}"] .message .product-group__message`).forEach(item=>{
                  item.classList.remove('show')
              })
              if(key.includes('group_limit')) {
              if(Number(value.limit)===0){
                  if(document.querySelector(`div[data-current-index="${value.index}"] .products-builder_list-of-products .message .no-places`)) {
                  document.querySelector(`div[data-current-index="${value.index}"] .products-builder_list-of-products .message .no-places`).classList.add('show')
                  document.querySelectorAll(`div[data-current-index="${value.index}"] .products-builder_list-of-products .builder-products_single`).forEach(item=>{
                    item.classList.add('disabled')
                  })
                  document.querySelector(`div[data-current-index="${value.index}"] .message`).classList.add('no-space-msg')
                  document.querySelector(`div[data-current-index="${value.index}"] .selected-counter`).classList.add('hide')
                  }
              } else {
                  document.querySelector(`div[data-current-index="${value.index}"] .message`).classList.remove('no-space-msg')
                  document.querySelector(`div[data-current-index="${value.index}"] .selected-counter`).classList.remove('hide')
                  const topMsg =  document.querySelector(`div[data-current-index="${value.index}"] .products-builder_list-of-products .message .available-places`);
                  if(topMsg) {
                  document.querySelector(`div[data-current-index="${value.index}"] .products-builder_list-of-products .message .available-places`).classList.add('show')
                  document.querySelector(`div[data-current-index="${value.index}"] .products-builder_list-of-products .message .available-places .insert-place`).innerHTML = value.limit
                  }
              }
              if(value.require && action === 'load'){
                  document.querySelector(`.next-btn[data-current-index="${value.index}"]`).classList.add('hide')
              }
          }

          if (Array.isArray(value) && value){
            value.forEach(item=>{

              const quantityInput = document.querySelector(`div[data-bundle-item-handle=${item.handle}] .bundle-item-quantity`);
              if (quantityInput) {
                Number(item.limit) !== 0 ? quantityInput.max = item.limit : quantityInput.max =1
                const spacesTaken = item.spaces;

                quantityInput.max > item.stockLevel ? quantityInput.max = item.stockLevel : quantityInput.max;
                quantityInput.setAttribute('data-space', quantityInput.max);
                quantityInput.setAttribute('data-space-used', spacesTaken);
                quantityInput.parentElement.setAttribute('data-space', quantityInput.max);
                quantityInput.parentElement.querySelector('.bundle-minus').setAttribute('data-space', quantityInput.max);
                quantityInput.parentElement.querySelector('.bundle-plus').setAttribute('data-space', quantityInput.max)
              }

            if(action === 'plus'){
              document.querySelectorAll(`div[data-bundle-item-handle=${item.handle}] .bundle-product-msgs`).forEach(item=>{
                if(!item.classList.contains('red')){
                  item.classList.remove('show')
                }

              })
            }
              const msgsDiv = document.querySelector(`div[data-bundle-item-handle=${item.handle}] .bundle-product-msgs`);
              const takesSpacesMsg = msgsDiv.querySelector('.takes-spaces');
              if (item.spaces <= 1 && item.limit <= 1) {
                if(!msgsDiv.classList.contains('not-compatible')) {
                  msgsDiv.classList.add('only-one-added')
                  msgsDiv.classList.remove('takes-spaces')
                  msgsDiv.classList.remove('not-compatible')
                }
              }
              else if (item.spaces > 1){
                msgsDiv.classList.add('takes-spaces')
                msgsDiv.classList.remove('only-one-added')
                msgsDiv.classList.remove('not-compatible')
                takesSpacesMsg.querySelector('.insert-place').textContent = item.spaces;
              }else {
                msgsDiv.classList.add('hide-all')
              }
            })
          }
        } else{
          document.querySelectorAll(`div[data-current-index="${value.index}"] .message .product-group__message`).forEach(item=>{
            item.classList.remove('show')
        })
          if(key.includes('group_limit')) {
          if(Number(value.limit)===0){
              if(document.querySelector(`div[data-current-index="${value.index}"] .products-builder_list-of-products .message .no-places`)) {
              document.querySelector(`div[data-current-index="${value.index}"] .products-builder_list-of-products .message .no-places`).classList.add('show')
              document.querySelectorAll(`div[data-current-index="${value.index}"] .products-builder_list-of-products .builder-products_single`).forEach(item=>{
                item.classList.add('disabled')
              })
              document.querySelector(`div[data-current-index="${value.index}"] .message`).classList.add('no-space-msg')
              document.querySelector(`div[data-current-index="${value.index}"] .selected-counter`).classList.add('hide')
              }
          } else {
              document.querySelector(`div[data-current-index="${value.index}"] .message`).classList.remove('no-space-msg')
              document.querySelector(`div[data-current-index="${value.index}"] .selected-counter`).classList.remove('hide')
              const topMsg =  document.querySelector(`div[data-current-index="${value.index}"] .products-builder_list-of-products .message .available-places`);
              if(topMsg) {
              document.querySelector(`div[data-current-index="${value.index}"] .products-builder_list-of-products .message .available-places`).classList.add('show')
              document.querySelector(`div[data-current-index="${value.index}"] .products-builder_list-of-products .message .available-places .insert-place`).innerHTML = value.limit
              }
          }
          if(value.require && action === 'load'){
              document.querySelector(`.next-btn[data-current-index="${value.index}"]`).classList.add('hide')
          }
      }
          if (Array.isArray(value) && value){
            value.forEach(item=>{

              const msgsDiv = document.querySelector(`div[data-bundle-item-handle=${item.handle}] .bundle-product-msgs`);
              const takesSpacesMsg = msgsDiv.querySelector('.takes-spaces');

              if (item.spaces <= 1 && item.limit <= 1) {
                  msgsDiv.classList.add('only-one-added')
                  msgsDiv.classList.remove('takes-spaces')
                  msgsDiv.classList.remove('not-compatible')
              }
              else if (item.spaces > 1){
                msgsDiv.classList.add('takes-spaces')
                msgsDiv.classList.remove('only-one-added')
                msgsDiv.classList.remove('not-compatible')
                takesSpacesMsg.querySelector('.insert-place').textContent = item.spaces;
              } else {
                msgsDiv.classList.add('hide-all')
              }
            })
          }
        }
      });
  }

  checkProductDetails('load')
  const currency = document.querySelector('.currency-selector__select option[selected=true]').value;
  document.querySelector('.currency-selector__select option[selected=true]')
  const resetBuildPopup = document.getElementById("resetBuildPopup");

  function moneyFilter(amount, currency) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(amount);
  }

  var selectedProducts  = []

  localStorage.setItem('allSkus', JSON.stringify(connectedProductsSkus))

  const plusButtons = document.querySelectorAll('.bundle-plus')
  const minusButtons = document.querySelectorAll('.bundle-minus')
  let originalLimitValue=[]

  function updateGroupSpace (selectedProducts) {
    for (let group in productDetails) {
        if (group.includes("limit")) {
          continue
        }
        for (let product of productDetails[group]) {
            if (product.handle === selectedProducts) {
              if (product.expansionIndex && product.expansionSpaces) {
                for (let group in productDetails) {
                  if (group.includes("limit")) {
                    if (Number(productDetails[group].index) === Number(product.expansionIndex)) {
                      const existingObjIndex = originalLimitValue.findIndex(obj => obj.hasOwnProperty(group));
                      if (existingObjIndex === -1) {
                        originalLimitValue.push({ [group]: productDetails[group].limit });
                      }
                      productDetails[group].limit = Number(productDetails[group].limit) + Number(product.expansionSpaces)
                    }
                  }
                }
              }
            }
        }
      }
  }

  function resetGroupSpace() {
    Object.entries(originalLimitValue).forEach(([key, value]) => {
      for(let i in value) {
        productDetails[i].limit = +value[i]
      }
    })

  }

  function getExcludes(){
    let excludes = {};
    // loop through all groups in mainData
    for (let group in productDetails) {
      // skip the group limit keys
      if (group.includes("limit")) {
        continue;
      }

      // loop through all products in the current group
      for (let product of productDetails[group]) {
        // save the exclude for the current product
          excludes[product.handle] = product.excludes;
      }
    }
    return excludes
  }

  function checkExcludes(selectedProducts, action) {
    let excludes = getExcludes()

    var alreadyExcluded =[]

      // remove all data to add again in bottom of this function
    document.querySelectorAll('.builder-products_single').forEach(item=>{
      item.classList.remove('excludes-disable')
      item.classList.remove('disabled')
    })

    document.querySelectorAll('.bundle-product-msgs>.bundle-product-msg').forEach(item=>{
      if(!item.classList.contains('red')){
        item.classList.remove('show')
      }
    })


    if(action === 'minus') {
      if(document.querySelectorAll('.bundle-product-msgs>.not-compatible').length>0){
        document.querySelectorAll('.bundle-product-msgs>.not-compatible').forEach(item=>{
          item.classList.remove('show')
          item.classList.remove('red')
        })
      }
    }

      // loop through all selected products and check for matching excludes
    if(selectedProducts.length>0){
          for (let selected of selectedProducts) {
            if(excludes[selected.handle]) {
              for (let exclude of excludes[selected.handle]) {
                alreadyExcluded.push(exclude)
                  // if an excluded product is also selected, return false
                if (exclude) {
                  const countValue = +document.querySelector(`div[data-bundle-item-handle=${exclude}]`).querySelector('.bundle-item-quantity').value;
                  if(countValue === 0) {
                    document.querySelector(`div[data-bundle-item-handle=${exclude}]`).classList.add('excludes-disable')
                    document.querySelector(`div[data-bundle-item-handle=${exclude}].excludes-disable .bundle-product-msgs`).classList.add('not-compatible')
                    document.querySelector(`div[data-bundle-item-handle=${exclude}].excludes-disable .bundle-product-msgs`).classList.remove('only-one-added')
                    document.querySelector(`div[data-bundle-item-handle=${exclude}].excludes-disable .bundle-product-msgs`).classList.remove('takes-spaces')
                    document.querySelector(`div[data-bundle-item-handle=${exclude}].excludes-disable .bundle-product-msgs>.not-compatible .insert-place`).innerHTML = selected.title
                  }
                }
              }
            }
          }
        } else {
      document.querySelectorAll('.builder-products_single').forEach(item=>{
        item.classList.remove('excludes-disable')
      })
    }
  }

  plusButtons.forEach(button => {
    button.addEventListener('click', ({currentTarget}) => {
      const productId = button.getAttribute('data-id');
      const currentElement = currentTarget.closest(".builder-products_single")
      const quantityElement = document.querySelector(`.bundle-item-quantity[data-id="${productId}"]`)
      const productHandle = document.querySelector(`.builder-products_single[data-bundle-item-id="${productId}"]`).getAttribute('data-bundle-item-handle')
      const productStep = parseInt(button.closest('.product-builder__group').getAttribute('data-current-index'),10)
      var quantity = Number(quantityElement.value)
      const singleProductSpace = Number(quantityElement.getAttribute('data-space'))

      let price = parseInt(button.closest('.builder-products_single').getAttribute('data-product-price'),10);
      const sku = document.querySelector(`.bundle-product-sku[data-id="${productId}"]`).getAttribute('data-sku')

      const newAllStkus = JSON.parse(localStorage.getItem('allSkus'))
      newAllStkus.push(sku);
      localStorage.setItem('allSkus', JSON.stringify(newAllStkus))

      getVariantModelAnimation()


      if(quantity < Number(quantityElement.max)){
        quantityElement.value = quantity + 1
      }

      const minusButton = button.previousElementSibling.previousElementSibling.previousElementSibling;
      if (Number(quantityElement.value) === Number(quantityElement.max)) {
        button.classList.add('button-disabled')
      }
      if (Number(quantityElement.value) >0) {
        minusButton.classList.remove('button-disabled');
      }
      let currentProductSpaces = 0;

      for (let [key, value] of Object.entries(productDetails)) {
        if(!key.includes('limit')) {
          value.forEach(product=>{
            if(product.id == productId) {
              currentProductSpaces = +product.spaces
            }
          })
        }
        
      }
      const productIndex = selectedProducts.findIndex(product => product.id === productId)

      if (productIndex !== -1) {
        selectedProducts[productIndex].quantity = Number(quantityElement.value)
      } else {
        selectedProducts.push({
          id: productId,
          title: button.parentElement.parentElement.querySelector('.builder-product-info p:first-child').innerHTML,
          quantity: Number(quantityElement.value),
          index: productStep,
          price: price,
          handle: productHandle,
          spaces: currentProductSpaces || 1
        })
      }
      quantityElement.nextElementSibling.nextElementSibling.innerHTML = 'x' + Number(quantityElement.value);

      localStorage.setItem('items', JSON.stringify(selectedProducts))

      // call function to check excluded products

      updateGroupSpace(productHandle)
      checkExcludes(selectedProducts, 'plus')
      checkProductDetails('plus')

      let totalStepPrice = 0;
      let totalTotalPrice = 0;
      let stepQuantity = 0;
      if(selectedProducts.length > 0){

        //check if group is require
        let checkRequire = selectedProducts.find(item=>item.index === productStep);

        if(checkRequire) {
          document.querySelector(`.next-btn[data-current-index="${productStep}"]`).classList.remove('hide')
        }
        selectedProducts.forEach(el => {
          if(el.index == productStep){
            // if product takes more that one space

            stepQuantity += el.quantity * el.spaces;
            if(el.spaces > 1) {
              totalStepPrice += el.price * (el.quantity*el.spaces);
            } else {
              totalStepPrice += el.price * el.quantity;
            }
            
            
            let totalStepPriceForShowing = totalStepPrice / 100
            document.querySelector(`.builder-accordion-header[data-current-index="${productStep}"] #total-price`).innerHTML = "(+"+moneyFilter(totalStepPriceForShowing, currency)+")"
            document.querySelector(`.product-builder__group[data-current-index="${productStep}"] .selected-counter`).innerHTML = `(${stepQuantity} selected)`;

            // disable other products when we don't have enough space
            let availableSpacesForGroup = document.querySelector(`.product-builder__group[data-current-index="${productStep}"] .available-places .insert-place`).innerHTML
            const parentBlock = document.querySelector(`.product-builder__group[data-current-index="${productStep}"]`)
            const allBlocks = parentBlock.querySelectorAll('.builder-products_single');

            // check if product spaces more tha available space for group
            allBlocks.forEach(block => {
              const singleProductSpace = block.querySelector('.bundle-item-quantity').getAttribute('data-space-used');
              const additionalSpace = +singleProductSpace + +stepQuantity;
              if(additionalSpace > parseInt(availableSpacesForGroup) && block !== currentElement){
                block.classList.add('disabled');
              }
            });

            if(stepQuantity === Number(availableSpacesForGroup)){

              allBlocks.forEach(block => {
                const blockInputValue = Number(block.querySelector('.bundle-item-quantity').value);
                // get disabled
                if (block.hasAttribute('data-bundle-item-id')) {
                  const currentIndex = block.getAttribute('data-bundle-item-id');
                  if (currentIndex !== productId && blockInputValue === 0) {
                    block.classList.add('disabled');
                  } else {
                    // ??? add part with excludes-disable
                    block.classList.remove('disabled');
                    // block.classList.remove('excludes-disable');
                    const addButton = block.querySelector('.bundle-plus');
                    addButton.classList.add('button-disabled')
                  }
                } else {
                  if (blockInputValue === 0) {
                    block.classList.add('disabled');
                  }
                }
              });
            }
          }
          totalTotalPrice += el.price

          let mainProductPrice = Number(document.querySelector('.product-builder-total-price span').getAttribute('data-builder-price'))
          mainProductPrice = mainProductPrice + totalTotalPrice
          document.querySelector('.product-builder-total-price span').setAttribute('data-price', mainProductPrice)
          mainProductPrice = mainProductPrice / 100
          document.querySelector('.product-builder-total-price span').innerHTML = moneyFilter(mainProductPrice ,currency);
        })
      }else{
        document.querySelector(`.builder-accordion-header[data-current-index="${productStep}"] #total-price`).innerHTML = ""
        document.querySelector(`.product-builder__group[data-current-index="${productStep}"] .selected-counter`).innerHTML = '(0 selected)';
      }
    })
  })

  minusButtons.forEach(button => {
    button.addEventListener('click', () => {
      const productId = button.getAttribute('data-id')
      const quantityElement = document.querySelector(`.bundle-item-quantity[data-id="${productId}"]`)
      var quantity = Number(quantityElement.value)
      const productStep = parseInt(button.closest('.product-builder__group').getAttribute('data-current-index'),10)
      const productHandle = document.querySelector(`.builder-products_single[data-bundle-item-id="${productId}"]`).getAttribute('data-bundle-item-handle')
      let price = parseInt(button.closest('.builder-products_single').getAttribute('data-product-price'),10);
      const sku = document.querySelector(`.bundle-product-sku[data-id="${productId}"]`).getAttribute('data-sku')

      for(const  [key, value] of Object.entries(productDetails)) {
        if (value.index === productStep) {
          if(value.require) {
            document.querySelector(`.next-btn[data-current-index="${value.index}"]`).classList.add('hide');
          }
        }
      }

      
      const newSelectedItems = JSON.parse(localStorage.getItem("items"));
      const productIndex = newSelectedItems.findIndex(product => product.id === productId);

      if (quantity === 1) {
        newSelectedItems.splice(productIndex, 1)
        selectedProducts.splice(productIndex, 1)
      } else {
        newSelectedItems[productIndex].quantity -= 1
        selectedProducts[productIndex].quantity -= 1
      }

      quantityElement.value = quantity - 1
      quantityElement.nextElementSibling.nextElementSibling.innerHTML = 'x' + Number(quantityElement.value);
      localStorage.setItem('items', JSON.stringify(newSelectedItems))


      checkExcludes(selectedProducts, 'minus')
      updateGroupSpace(productHandle);
      if(document.querySelector(`.builder-products_single[data-bundle-item-id="${productId}"]`).getAttribute('data-expansion-index')) {
        resetGroupSpace();
      }
      checkProductDetails('minus');

      const plusButton = button.nextElementSibling.nextElementSibling.nextElementSibling;
      if (Number(quantityElement.value) === 0) {
        button.classList.add('button-disabled')
        plusButton.classList.remove('button-disabled');
      }
      if (Number(quantityElement.value) > 0 && Number(quantityElement.value) < Number(quantityElement.max)) {
        button.classList.remove('button-disabled')
        plusButton.classList.remove('button-disabled');
      }


      let totalStepPrice = 0;
      let totalTotalPrice = 0;
      let stepQuantity = 0;
      if(selectedProducts.length > 0){
        let thisStepCounter = 0;
        selectedProducts.forEach(el => {
          if(el.index == productStep){
            thisStepCounter+=1

            stepQuantity += el.quantity * el.spaces;
            if(el.spaces > 1) {
              totalStepPrice += el.price * (el.quantity*el.spaces);
            } else {
              totalStepPrice += el.price * el.quantity;
            }


            let totalStepPriceForShowing = totalStepPrice / 100
            document.querySelector(`.builder-accordion-header[data-current-index="${productStep}"] #total-price`).innerHTML = "(+"+moneyFilter(totalStepPriceForShowing,currency)+")"
            document.querySelector(`.product-builder__group[data-current-index="${productStep}"] .selected-counter`).innerHTML = `(${stepQuantity} selected)`;

            // disable other products when we don't have enough space
            let availableSpacesForGroup = document.querySelector(`.product-builder__group[data-current-index="${productStep}"] .available-places .insert-place`).innerHTML
            const parentBlock = document.querySelector(`.product-builder__group[data-current-index="${productStep}"]`)
            const allBlocks = parentBlock.querySelectorAll('.builder-products_single');

            // check if product spaces more tha available space for group

            if(stepQuantity !== Number(availableSpacesForGroup)){
              allBlocks.forEach(block => {
                const singleProductSpace = block.querySelector('.bundle-item-quantity').getAttribute('data-space-used');
                const additionalSpace = +singleProductSpace + +stepQuantity
                const blockID = block.getAttribute('data-bundle-item-id')
                const isActiveElement = selectedProducts.find(product=>product.id == blockID);
                if(additionalSpace > +availableSpacesForGroup && !isActiveElement){
                  block.classList.add('disabled');
                } else {
                  block.classList.remove('disabled');
                  const addButton = block.querySelector('.bundle-plus');
                  const blockQuantity = block.querySelector('.bundle-item-quantity')

                  if(blockQuantity.value < blockQuantity.max) {
                    addButton.classList.remove('button-disabled')
                  }
                }
              });
            }

          }
          totalTotalPrice += el.price
          let mainProductPrice = Number(document.querySelector('.product-builder-total-price span').getAttribute('data-builder-price'))
          mainProductPrice = mainProductPrice + totalTotalPrice
          document.querySelector('.product-builder-total-price span').setAttribute('data-price', mainProductPrice)
          mainProductPrice = mainProductPrice / 100
          document.querySelector('.product-builder-total-price span').innerHTML = moneyFilter(mainProductPrice ,currency);

        })
        if(thisStepCounter == 0){
          document.querySelector(`.builder-accordion-header[data-current-index="${productStep}"] #total-price`).innerHTML = ""
          document.querySelector(`.product-builder__group[data-current-index="${productStep}"] .selected-counter`).innerHTML = '(0 selected)';
        }
      }else{
        let clearProductPrice = Number(document.querySelector('.product-builder-total-price span').getAttribute('data-builder-price'))
        let mainProductPrice = clearProductPrice / 100
        document.querySelector('.product-builder-total-price span').setAttribute('data-price', clearProductPrice)
        document.querySelector('.product-builder-total-price span').innerHTML = moneyFilter(mainProductPrice ,currency);
        document.querySelector(`.builder-accordion-header[data-current-index="${productStep}"] #total-price`).innerHTML = ""
        document.querySelector(`.product-builder__group[data-current-index="${productStep}"] .selected-counter`).innerHTML = '(0 selected)';
      }

      const newAllStkus = JSON.parse(localStorage.getItem('allSkus'))
      const hasSku = newAllStkus.filter(itemSku=> itemSku.includes(sku))
      if (hasSku) {
        const index = newAllStkus.indexOf(sku)
        // Remove the sku from the array if it already exists
        newAllStkus.splice(index, 1)
        localStorage.setItem('allSkus', JSON.stringify(newAllStkus))
      }
      if(!newSelectedItems.length) {
        localStorage.setItem('allSkus', JSON.stringify(baseProductsSkus))
      }
      getVariantModelAnimation()
    })
  })

  document.addEventListener('click', function(e){

    if(e.target.closest('.next-btn')){
        const detailsContainer = document.querySelector(".product-details")
        let index =  parseInt(e.target.getAttribute('data-current-index'), 10)

        e.target.closest('.product-builder__group').classList.remove('is-active') //close step
        e.target.closest('.builder-accordion-item').classList.add('reached') // chage step label
        e.target.closest('.builder-accordion-item').querySelector('.builder-edit').classList.remove('hide-class')

        if(!e.target.closest('.next-btn').classList.contains('finish-btn')){
          document.querySelector(`.product-builder__group[data-current-index="${index + 1}"]`).classList.add('is-active') // open next step
        }else{
          document.querySelector('.product-submit-wrapper .select-options-btn').style.display = 'none';
          document.querySelector('.product-submit-wrapper input[type="submit"]').style.display = 'block';
        }

        // displaing added products
        let addedItems = JSON.parse(localStorage.getItem("items"));
        addedItems?.forEach(el => {
          if(el.index == index){
            document.querySelector(`.product-builder__group--selected[data-current-index="${index}"]`).appendChild(document.querySelector(`.builder-products_single[data-bundle-item-id="${el.id}"]`).cloneNode(true))
          }
        })
        detailsContainer.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    const resetStep = (e, currentIndex) => {
      let step = currentIndex ? currentIndex : Number(e.target.closest('.builder-accordion-header').getAttribute('data-current-index'));
      let selectedItems = JSON.parse(localStorage.getItem("items"));
      let newSelectedItems;
      if(selectedItems){
          newSelectedItems = selectedItems.filter(product => product.index <= step);
          selectedProducts = selectedProducts.filter(product => product.index <= step);
          localStorage.setItem("items", JSON.stringify(newSelectedItems));
      }
          let headers = document.querySelectorAll('.builder-accordion-header')
          var skusForRemove =[]

          for(let i = 1; i <= headers.length; i++){
            if(i > step){
              
              document.querySelector(`.builder-accordion-header[data-current-index="${i}"] #total-price`).innerHTML = ""
              document.querySelector(`.builder-accordion-header[data-current-index="${i-1}"] .builder-edit`).classList.add('hide-class')
              document.querySelector(`.builder-accordion-header[data-current-index="${i}"]`).closest('.builder-accordion-item').classList.remove('reached')
              document.querySelector(`.product-builder__group--selected[data-current-index="${i}"]`).innerHTML = "";
              document.querySelector(`.product-builder__group[data-current-index="${i}"]`).classList.remove('is-active')
              if(i != step){
                document.querySelector(`.builder-accordion-header[data-current-index="${i}"] #total-price`).innerHTML = ''
              }
              const counters = document.querySelectorAll(`.product-builder__group[data-current-index="${i}"] .bundle-quantity-block`)

              counters.forEach(el=>{
                el.querySelector(".bundle-minus").classList.add("button-disabled");
                el.querySelector(".bundle-plus").classList.remove("button-disabled")
                el.querySelector(".bundle-item-quantity").value = 0;
              })

              document.querySelector(`.product-builder__group[data-current-index="${i}"] .selected-counter`).innerHTML = "(0 selected)"

              document.querySelectorAll(`.product-builder__group[data-current-index="${i}"] .bundle-product-sku`).forEach(el => {
                skusForRemove.push(el.getAttribute('data-sku'))
              })

              for(const  [key, value] of Object.entries(productDetails)) {
                if (value.index === i) {
                  if(value.require) {
                    document.querySelector(`.next-btn[data-current-index="${value.index}"]`).classList.add('hide');
                  }
                }
              }
            }

            if(i == step){
              document.querySelector(`.product-builder__group--selected[data-current-index="${i}"]`).innerHTML = "";
              let stepQuantity = 0
              let availableSpacesForGroup = document.querySelector(`.product-builder__group[data-current-index="${step}"] .available-places .insert-place`).innerHTML
              if(newSelectedItems) {
                newSelectedItems.forEach(el => {
                  if(el.index == step){
                    stepQuantity += el.quantity * el.spaces;
                  }
                })
              }
              
              if(stepQuantity == Number(availableSpacesForGroup)){
                const parentBlock = document.querySelector(`.product-builder__group[data-current-index="${step}"]`)
                let allBlocks = parentBlock.querySelectorAll(`.builder-products_single`);
                  allBlocks.forEach(block => {
                  const blockInputValue = Number(block.querySelector('.bundle-item-quantity').value);
                  // get disabled
                  if (block.hasAttribute('data-bundle-item-id')) {
                    const singleProductSpace = block.querySelector('.bundle-item-quantity').getAttribute('data-space');
                    const additionalSpace = +singleProductSpace > 0 ? +singleProductSpace + +stepQuantity: 1 + +stepQuantity
                    if(additionalSpace > +availableSpacesForGroup && blockInputValue === 0) {
                      block.classList.add('disabled');
                    } 
                  }
                });
              }
            }
          }

      let alreadySelected = JSON.parse(localStorage.getItem('allSkus'))
      if(alreadySelected){
        const uniqueArray = alreadySelected.filter((item) => skusForRemove.indexOf(item) === -1);
        localStorage.setItem('allSkus', JSON.stringify(uniqueArray))
        getVariantModelAnimation()

        document.querySelector(`.product-builder__group[data-current-index="${step}"]`).classList.add('is-active')
        document.querySelector('.product-submit-wrapper .select-options-btn').style.display = 'block';
        document.querySelector('.product-submit-wrapper input[type="submit"]').style.display = 'none';
      }
    }

    if(e.target.closest('.builder-edit')){
      resetBuildPopup.showModal();
      const index = e.target.closest('.builder-accordion-header').getAttribute('data-current-index');
      resetBuildPopup.setAttribute('data-current-index', index)
    }

    if(e.target === resetBuildPopup) {
      resetBuildPopup.close();
    }

    if(e.target.classList.contains('product-warning__cancel')) {
      resetBuildPopup.close();
    }

    if(e.target.closest('.product-warning__close') || e.target.classList.contains('product-warning__close')) {
      resetBuildPopup.close();
    }

    if(e.target.classList.contains('product-warning__edit')) {
      const index = resetBuildPopup.getAttribute('data-current-index');
      resetStep(null, index);
      resetBuildPopup.close();
    }

    if(e.target.classList.contains('builder-btn')) {
      document.querySelector('[data-builder-modal]').classList.add('active');
    }
    if(e.target.classList.contains('closeBuilder')) {
      document.querySelector('[data-builder-modal]').classList.remove('active');
    }
  })
  }
})